import { render, staticRenderFns } from "./productLog.vue?vue&type=template&id=40530d3a&scoped=true&"
import script from "./productLog.vue?vue&type=script&lang=js&"
export * from "./productLog.vue?vue&type=script&lang=js&"
import style0 from "./productLog.vue?vue&type=style&index=0&id=40530d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40530d3a",
  null
  
)

export default component.exports